var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.292,
    height: 22.959,
    viewBox: "0 0 36.292 22.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18695",
    "data-name": "Group 18695",
    transform: "translate(-1371.414 -907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25781",
    "data-name": "Path 25781",
    d: "M57.018,33.526H52.612V29.119H49.8v4.407H45.393v2.812H49.8v4.407h2.812V36.337h4.407Z",
    transform: "translate(1350.688 883.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25782",
    "data-name": "Path 25782",
    d: "M32.505,31.074H21.829l.013,3.058h7.2c-.851,3.724-3.478,6.006-7.005,6.006a8.375,8.375,0,1,1,5.694-14.514l2.362-2.036a11.479,11.479,0,1,0-8.056,19.656c6.089,0,10.488-4.644,10.488-10.984Z",
    transform: "translate(1360.858 886.717)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.6cb6221fa6cd11c4c0c7738431d3a6f9.svg";
export { ForwardRef as ReactComponent };